export type CommentaryPosition = 'above' | 'below' | 'left' | 'right';

export interface CommentaryEntry {
  html: string;
  position?: CommentaryPosition;
}
export const COMMENTARY: Record<string, CommentaryEntry | undefined> = {
  'B93': {
    html: 'For CEs, <a href="https://eceweb.uwaterloo.ca/~smzahedi/crs/ece252/">ECE 252: Systems Programming and Concurrency</a> and<br/><a href="https://uwflow.com/course/ECE320">ECE 320: Computer Architecture</a> (technically not a required course)<br/>For EEs, <a href="https://uwflow.com/course/ece206">ECE 206: Advanced Calculus 2 for Electrical Engineers</a>',
    position: 'below'
  },
  'B94': {
    html: '<For CEs, a href="https://eceweb.uwaterloo.ca/~smzahedi/crs/ece252/">ECE 459: Programming for Performance</a> and<br/><a href="https://github.com/jzarnett/ece459">ECE 320: Computer Architecture</a><br/>For EEs, <a href="https://uwflow.com/course/ECE463">ECE 463: Design and Applications of Power Electronic Converters<a/> and <br/><a href="https://uwflow.com/course/ECE373">ECE 373: Radio Frequency and Microwave Circuits<a/>',
    position: 'below'
  }
};

export function getCommentary(questionId: string): CommentaryEntry | undefined {
  return COMMENTARY[questionId];
}
